import styles from './RadioGroup.module.css'
import type { Radio } from '../RadioVariantSelector/RadioVariantSelector'
import { RadioVariantSelector } from '../RadioVariantSelector/RadioVariantSelector'

interface RadioGroupProps {
  type: 'button' | 'text' | 'color'
  name: string
  radios?: Radio[]
  heading: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const RadioGroup = ({ type, radios, heading, name, onChange }: RadioGroupProps) => {
  if (!radios) {
    return null
  }

  return (
    <fieldset className={styles.RadioGroup}>
      <legend className={styles.RadioGroup__legend}>{heading}</legend>
      <div className={styles.RadioGroup__radios} role="radiogroup">
        {radios.map((radio) => {
          return <RadioVariantSelector key={radio.id} radio={radio} name={name} type={type} onChange={onChange} />
        })}
      </div>
    </fieldset>
  )
}
